

export const IN_MAINTENANCE_MODE = "1" as const;
export const IN_OPERATION_MODE = "0" as const;
export const ACTIVE = "ACTIVE" as const;
export const BANNED = "BANNED" as const;
export const SUSPENDED = "SUSPENDED" as const;
//export const API_URL = "http://localhost:8004" as const;

const parsedUrl = new URL(window.location.href);
      
//export const API_URL = parsedUrl.origin;

//this.baseUrl = 'http://localhost:8090';

//export const API_URL = "http://10.33.1.199:8004" as const;

//export const API_URL = "http://localhost:8004" as const;
//export const API_URL = "http://localhost:8004" as const;
//export const API_URL = "http://151.192.71.226:8090/lclocal" as const;
//export const API_URL = "http://192.168.20.18:8090/lclocal" as const;
 export const API_URL = "https://cloud.goldhillmc.com:4200" as const;
//export const API_URL = "http://10.33.1.65:3000" as const;
//export const API_URL = "http://192.168.0.33:8003" as const;

export const DEBUG = true as const;
export const ERROR_MAINTENANCE = "IN MAINTENANCE" as const;
export const TOKEN_EXPIRED = "Token Expired" as const;

/** Session variable name */


export const MAIN_ACCOUNT_ID = "mainAccountId" as const;
export const AUTHENTICATED_USER = "authenticaterUser" as const;
export const LOGIN_ACCOUNT_NAME = "loginAccountName" as const;

export const AUTHENTICATED_USER_PASSWORD = "authenticaterUserPassword" as const;
export const TOKEN = "token" as const;
export const ACCOUNT_ID_DROPDOWN_OPTIONS = "ACCOUNT_ID_DROPDOWN_OPTIONS" as const;

/** Login Page */

export const LOGIN_MESSAGE = "LOGIN_MESSAGE" as const;
export const LOGIN_MESSAGE_INVALID_USERNAME_OR_PASSWORD =
  "Invalid user name or password. " as const;
export const LOGIN_MESSAGE_EXCEEDED_LOGIN_ATTEMPTS =
  "Exceeded maximum login attempts. " as const;
export const LOGIN_MESSAGE_ACCOUNT_LOCKED = "Your account is locked. " as const;
export const LOGIN_MESSAGE_ACCOUNT_SUSPENDED = "Your account is suspended. " as const;
export const LOGIN_MESSAGE_ACCOUNT_BANNED = "Your account is banned. " as const;

export const DATE_FORMAT = "yyyy-MM-dd HH:mm:ss.SSS";
/** Regex for validation */

//?999999
export const ACCOUNT_ID_REGEX = "^[M|S][0-9]{6}(-[0-9]{2})?$";
//M999999
export const MAIN_ACCOUNT_ID_REGEX = "^[M][0-9]{6}$";
//S999999-99
export const SUB_ACCOUNT_ID_REGEX = "^[S][0-9]{6}[-][0-9]{2}$";
//11-111-111
export const LOCATION_ID_REGEX = "^[0-9]{2}-[0-9]{3}-[0-9]{3}$" as const;
//31/12/2000
export const DD_MM_YYYY_DATE_REGEX = "^(3[01]|[12][0-9]|0[1-9])/(1[0-2]|0[1-9])/[0-9]{4}$" as const;
//23:59
export const HH_MM_TIME_REGEX = "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$";

export const POSTAL_CODE = "^[0-9]{6}$";

export const SINGAPORE_PHONE_NO = "^(6|8|9)[0-9]{7}$";



/** Error string */

export const DATA_OUTDATED = "Data is outdated" as const;
export const DATA_OUTDATED_ALERT_MESSAGE = "Please try again. (Err: Outdated data)" as const;




/** systemSettingColumn name const */

export const OBS_IS_UNDER_MAINTENANCE = "obs_is_under_maintenance" as const;

export const VIP_BOOKING_SLOT = "vip_booking_slot" as const;
export const VIP_VISIT_DURATION = "vip_visit_duration" as const;
export const VIP_NEW_VISIT_DURATION_EFFECTIVE_DATE = "vip_new_visit_duration_effective_date" as const;
export const VIP_NEW_VISIT_DURATION = "vip_new_visit_duration" as const;


export const NORMAL_BOOKING_SLOT = "normal_booking_slot" as const;
export const NORMAL_VISIT_DURATION = "normal_visit_duration" as const;
export const NORMAL_NEW_VISIT_DURATION_EFFECTIVE_DATE = "normal_new_visit_duration_effective_date" as const;
export const NORMAL_NEW_VISIT_DURATION = "normal_new_visit_duration" as const;


export const BOOKING_NO_SHOW_LIMIT = "booking_no_show_limit" as const;
export const ACCOUNT_BAN_DURATION = "account_ban_duration" as const;
export const BOOKING_MIN_ADVANCE_DAY = "booking_min_advance_day" as const;
export const BOOKING_MAX_ADVANCE_DAY = "booking_max_advance_day" as const;
export const BOOKING_CANCEL_ADVANCE_DAY = "booking_cancel_advance_day" as const;


export const VISITATION_GRACE_PERIOD = "visitation_grace_period" as const;
export const NO_OF_VISIT_PER_DAY = "no_of_visit_per_day" as const;
export const QUEUE_TV_INITIAL_ALERT_SECOND = "queue_tv_initial_alert_second" as const;
export const QUEUE_TV_SUBSEQUENT_ALERT_SECOND = "queue_tv_subsequent_alert_second" as const;
export const VIEW_BOOTH_NO_SHOW_LIMIT = "view_booth_no_show_limit" as const;
export const NORMAL_BOOTH_ALLOCATION_WALK_IN = "normal_booth_allocation_walk_in" as const;
export const NORMAL_BOOTH_ALLOCATION_BOOKING = "normal_booth_allocation_booking" as const;
export const VIP_BOOTH_ALLOCATION_WALK_IN = "vip_booth_allocation_walk_in" as const;
export const VIP_BOOTH_ALLOCATION_BOOKING = "vip_booth_allocation_booking" as const;

export const SEND_EMAIL_REMINDER = "send_email_reminder" as const;
export const B3_WAITING_AREA_AVAILABILITY = "b3_waiting_area_availability" as const;
export const LIFE_CORP_TEL_NO = "life_corp_tel_no" as const;
export const LIFE_CORP_FAX_NO = "life_corp_fax_no" as const;
export const OPERATING_HOUR_FROM = "operating_hour_from" as const;
export const OPERATING_HOUR_TO = "operating_hour_to" as const;
export const NEW_OPERATING_HOUR_FROM = "new_operating_hour_from" as const;
export const NEW_OPERATING_HOUR_TO = "new_operating_hour_to" as const;
export const OPERATING_HOUR_EFFECTIVE_DATE = "operating_hour_effective_date" as const;
